import React from 'react'
import ButtonBase, { ButtonBaseProps } from '@material-ui/core/ButtonBase'
import QuizModeButtonIcon from '../QuizModeButtonIcon'

type InjectedProps = ButtonBaseProps

const QuizModeButton: React.SFC<InjectedProps> = (props) => {
  return (
    <ButtonBase {...props}>
      <QuizModeButtonIcon />
    </ButtonBase>
  )
}

export default QuizModeButton
